import { ChainName } from '../static'
import Web3 from 'web3'

export const calculatePasswordStrength = (
  password: string
): {
  error: string | null
  bar: { strengthColor: string; value: number }
} => {
  let conditionsFulfilled = 0
  conditionsFulfilled += password.length > 7 ? 1 : 0 // at least 8 chars
  conditionsFulfilled += /[a-z]/g.test(password) ? 1 : 0 // at least one lowercase
  conditionsFulfilled += /[A-Z]/g.test(password) ? 1 : 0 // at least one uppercase
  conditionsFulfilled += /[0-9]/g.test(password) ? 1 : 0 // at least one number
  conditionsFulfilled += /[\^$*.[\]{}()?\-"!@#%&/,><’:;|_~`]/g.test(password) ? 1 : 0 // at least one of  the special characters listed by cognito

  let error: string | null = null
  if (conditionsFulfilled < 5) {
    error =
      'Your password should have at least 8 characters, one uppercase, one lowercase, one number and one special character'
  }

  const bar = {
    strengthColor: 'disabled',
    value: 0
  }
  if (conditionsFulfilled > 0) {
    if (conditionsFulfilled > 2) {
      if (conditionsFulfilled > 4) {
        ;[bar.strengthColor, bar.value] = ['strong', 100]
      } else {
        ;[bar.strengthColor, bar.value] = ['medium', 66]
      }
    } else {
      ;[bar.strengthColor, bar.value] = ['weak', 33]
    }
  }

  return { error, bar }
}

export const isEmailValid = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

// 3 digits
export const isInstitutionNumValid = (institutionNum: string): boolean => {
  return /^\d{3}$/.test(institutionNum)
}

// 5 digits
export const isTransitNumValid = (transitNum: string): boolean => {
  return /^\d{5}$/.test(transitNum)
}

export const isAchCodeValid = (achCode: string): boolean => {
  return achCode.length === 9
}

export const isSwiftBicCodeValid = (swiftBicCode: string): boolean => {
  return swiftBicCode.length >= 8 && swiftBicCode.length <= 11
}

// 7 or 12 digits
export const isCanadaAcctNumValid = (accountNum: string): boolean => {
  return /^\d{7}$|^\d{12}$/.test(accountNum)
}

// 6-17 digits
export const isUSAcctNumValid = (accountNum: string): boolean => {
  return accountNum.length >= 6 && accountNum.length <= 17
}

export const isBlockchainAddressValid = (address: string, chain: ChainName): boolean => {
  const web3 = new Web3()
  if (chain === ChainName.ETHEREUM && !web3.utils.isAddress(address)) {
    return false
  }
  return true
}

export class ValidationError extends Error {
  constructor(msg: string) {
    super(msg)
    Object.setPrototypeOf(this, ValidationError.prototype)
  }
}
